import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "predefined-template"
    }}>{`Predefined Template`}</h1>
    <p>{`Predefined Template allows the admin to import a search page layout that is previously built or provided by the plugin(Built-in). Moreover, now you can save any search layout at any time that you are building. Let's check how someone can use the feature.`}</p>
    <p>{`When the site admin opens a blank search page to build the search page, it appears like the following screenshot.`}</p>
    <p><img alt="predefined_template_1.png" src={require("../images/predefined_template_1.png")} /></p>
    <p>{`Now, the site admin can build the search page from scratch using the button `}<inlineCode parentName="p">{`Add Block`}</inlineCode>{`. or he can select any predefined template by clicking the button `}<inlineCode parentName="p">{`Select Template`}</inlineCode>{`. If the admin clicks the button `}<inlineCode parentName="p">{`Select Template`}</inlineCode>{` it will look like the following screenshot.`}</p>
    <p><img alt="predefined_template_2.png" src={require("../images/predefined_template_2.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`NB: Please give your template name carefully so that you can track them back later, it's better to give it the same name as your reactive builder shortcode title`}</p>
    </blockquote>
    <p>{`It is the list of the Search Page Layout that the admin can choose. After choosing one the Search Page will look like the following screenshot.`}</p>
    <p><img alt="predefine_template_3.png" src={require("../images/predefine_template_3.png")} /></p>
    <p>{`Only the layout will be imported. Currently, we did not provide the facility to import the setting. Now, after changing a little on the template you can save it as a `}<inlineCode parentName="p">{`new template`}</inlineCode>{` and `}<inlineCode parentName="p">{`override previous one`}</inlineCode>{`.`}</p>
    <p><img alt="predefine_template_4.png" src={require("../images/predefine_template_4.png")} /></p>
    <p>{`Then the search page will look like the following.`}</p>
    <p><img alt="predefined_template_5.png" src={require("../images/predefined_template_5.png")} /></p>
    <p>{`So, Build your page And Save It and import when even you like on building another search Page. `}<strong parentName="p">{`Enjoy!`}</strong></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      